module.exports = __webpack_public_path__ + "img/node.27881c2a.svg";